import {
  ArrowUpRight,
  BookOpen,
  Folder,
  LayoutGrid,
  RefreshCw,
  Settings,
  Users,
} from "lucide-react";
import { NavLink } from "react-router";
import { OrgSwitcher } from "./OrgSwitcher";
import { WardMark } from "./WardMark";

const sections = [
  {
    label: "Workspace",
    items: [
      { to: "/", label: "Overview", icon: LayoutGrid },
      { to: "/projects", label: "Projects", icon: Folder },
      { to: "/rotators", label: "Rotators", icon: RefreshCw, soon: true },
    ],
  },
  {
    label: "Manage",
    items: [
      { to: "/members", label: "Members", icon: Users },
      { to: "/settings", label: "Settings", icon: Settings },
    ],
  },
];

export function Sidebar({ onNavigate }: { onNavigate?: (() => void) | undefined }) {
  return (
    <nav className="workspace-nav" aria-label="Main navigation">
      <NavLink to="/" onClick={onNavigate} className="brand" aria-label="Wardkey">
        <WardMark className="size-7 text-accent" />
        <span>
          wardkey<span className="text-accent">.</span>
        </span>
      </NavLink>
      <OrgSwitcher onNavigate={onNavigate} />
      <div className="nav-sections">
        {sections.map((section) => (
          <div key={section.label}>
            <p className="eyebrow nav-label">{section.label}</p>
            <ul>
              {section.items.map((item) => (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.to === "/"}
                    onClick={onNavigate}
                    className={({ isActive }) => `nav-item${isActive ? " is-active" : ""}`}
                  >
                    <item.icon size={18} strokeWidth={1.6} aria-hidden="true" />
                    <span>{item.label}</span>
                    {"soon" in item && <span className="nav-soon">Soon</span>}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <a className="nav-docs" href="https://wardkey.app/docs/cli" target="_blank" rel="noreferrer">
        <BookOpen size={17} aria-hidden="true" />
        <span>Documentation</span>
        <ArrowUpRight size={14} aria-hidden="true" />
      </a>
      <div className="nav-footnote">A safe place for your secrets.</div>
    </nav>
  );
}
